import { request } from './client';
import { Card } from '../types/card';
import {
  StudyQueueResponse,
  ReviewPayload,
  ReviewResponse,
  ReviewsListResponse,
  StudyQueueMode,
  StudyQueueCounts,
} from '../types/study';

export async function fetchStudyQueue(
  deck_id?: string,
  limit: number = 30,
  mode: StudyQueueMode = 'all',
  signal?: AbortSignal
): Promise<StudyQueueResponse> {
  const query = new URLSearchParams();
  if (deck_id) query.set('deck_id', deck_id);
  query.set('limit', String(limit));
  query.set('mode', mode);
  query.set('detail', 'study');

  return request<StudyQueueResponse>(`/study/queue?${query.toString()}`, { signal });
}

export async function submitReview(payload: ReviewPayload): Promise<ReviewResponse> {
  return request<ReviewResponse>('/reviews', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function undoReview(
  review_id: string
): Promise<{ ok: boolean; card?: Card; counts?: StudyQueueCounts; already_undone?: boolean; message?: string }> {
  return request<{ ok: boolean; card?: Card; counts?: StudyQueueCounts; already_undone?: boolean; message?: string }>(
    `/reviews/${encodeURIComponent(review_id)}/undo`,
    {
      method: 'POST',
      body: JSON.stringify({}),
    }
  );
}

export async function fetchReviews(
  card_id?: string,
  limit: number = 100
): Promise<ReviewsListResponse> {
  const query = new URLSearchParams();
  if (card_id) query.set('card_id', card_id);
  query.set('limit', String(limit));

  return request<ReviewsListResponse>(`/reviews?${query.toString()}`);
}
